import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useState } from '@redneckz/uni-jsx/lib/hooks';
import { renderButtonsSection } from '../../ui-kit/LinkButton/renderButtonsSection.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { isIcon } from '../../utils/isIcon.js';
import { style } from '../../utils/style.js';
import { findIconByHref } from './findIconByHref.js';
export const SocialMedia = JSX(({ className = '', media, showButtonText, stretched, version = 'white', children }) => {
    if (!media?.length) {
        return null;
    }
    const [hasText, setHasText] = useState();
    const buttons = media?.map((_) => {
        const { href, icon, text } = _;
        const { iconMapped } = findIconByHref(href);
        const iconCustom = isIcon(icon) ? icon : iconMapped;
        const buttonText = showButtonText ? { text } : { text: '' };
        const iconVersion = _?.icon?.iconVersion || 'color';
        if (!hasText && text) {
            setHasText(true);
        }
        return {
            ..._,
            ...buttonText,
            icon: { ...iconCustom, iconVersion: iconVersion },
            version: _?.version ?? version,
        };
    });
    const buttonClassName = style('border border-solid hover:border-transparent border-main-divider', 'group-data-primary:border-main-divider group-data-gray:border-green group/media', {
        'basis-auto': !showButtonText && !hasText,
    }, getStretchedStyle(stretched));
    return (_jsxs("div", { className: style('flex flex-col gap-m xl:gap-xs', className), "aria-label": "\u0421\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u0435\u0442\u0438", children: [_jsx("div", { className: "flex gap-xs", children: renderButtonsSection(buttons, {
                    className: getClassName(hasText ?? false, stretched ?? false, showButtonText),
                    buttonClassName,
                }) }), children ? (_jsx(Text, { size: "text-s", font: "font-light", color: "text-secondary-text", children: children })) : null] }));
});
const getStretchedStyle = (stretched = false) => stretched ? 'flex-1 @lg:flex-initial justify-center' : '';
const getClassName = (hasText, stretched, showButtonText = false) => style(hasText || stretched ? 'basis-full' : '', stretched && (showButtonText ? !hasText : true) ? 'flex-nowrap' : '');
//# sourceMappingURL=SocialMedia.js.map